<h2 mat-dialog-title>{{ 'actions.remove_employee' | translate }}?<span class="icon-close icon-Cross" mat-dialog-close></span></h2>
<mat-dialog-content>
  <div class="dialog-content">
    <h3>{{ 'messages.remove_employee' | translate: { employee: data.employeeName, company: data.companyName } }}</h3>
    <mat-form-field>
      <input matInput [placeholder]="'form.fields.confirm_delete' | translate" [(ngModel)]="confirmText" />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button class="btn-main btn-secondary-purple btn-xl" [disabled]="confirmText.trim() !== 'DELETE'" (click)="confirm()">
    {{ 'actions.delete' | translate }}
  </button>
  <button class="btn-main btn-primary btn-xl" mat-dialog-close>{{ 'actions.cancel' | translate }}</button>
</mat-dialog-actions>
